import { useMutation, useQuery } from "@tanstack/react-query";

import { getTranscriptList } from "@src/api";
import { useNotification } from "@src/hooks/useNotification";
import {
  getAutocompleteResults,
  getPotentialOfftargetList,
  getPrimerDesignDownload,
  getResult,
  getGenomeAssemblies,
  getDNAResult,
} from "@src/api/api";

export const useGetTranscriptQuery = (setLoading: any) => {
  // const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationKey: ["editorResults"],
    mutationFn: getTranscriptList,

    onSuccess: ({ data }) => {
      setLoading(false);
      return data;
    },
    onError: (error: any) => {
      setLoading(false);
      showNotification({
        content: error.message || error,
        type: "alert",
      });
    },
  });
};

export const useGetResultDataQuery = (setLoading: any) => {
  // const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationKey: ["editorResults"],
    mutationFn: getResult,

    onSuccess: ({ data }) => {
      setLoading(false);
      return data;
    },
    onError: (error: any) => {
      setLoading(false);
      console.error("error::", error);
      showNotification({
        content: error.message || error,
        type: "alert",
      });
    },
  });
};

export const useGetOnlyDNAResultDataQuery = (setLoading: any) => {
  // const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationKey: ["editorDnaResults"],
    mutationFn: getDNAResult,

    onSuccess: ({ data }) => {
      setLoading(false);
      return data;
    },
    onError: (error: any) => {
      setLoading(false);
      console.error("error::", error);
      showNotification({
        content: error.message || error,
        type: "alert",
      });
    },
  });
};

export const useGetPOfftargetQuery = (setLoading: any) => {
  // const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationKey: ["editorResults"],
    mutationFn: getPotentialOfftargetList,

    onSuccess: ({ data }) => {
      setLoading(false);
      return data;
    },
    onError: (error: any) => {
      setLoading(false);
      showNotification({
        content: error.message || error,
        type: "alert",
      });
    },
  });
};

// export const useGetAutocompleteQuery = (genome: string, query = "") => {
//   const gnom: any = getGenomeValue(genome);
//   return useQuery({
//     queryKey: ["autocomplete", query],
//     queryFn: () => getAutocompleteResults(gnom, query),
//     select: ({ data }) => data,
//     enabled: Boolean(query),
//     staleTime: Infinity,
//     retry: false,
//   });
// };

export const useGetAutocompleteQuery = (genome: string, query = "") => {
  const gnom: any = getGenomeValue(genome);
  return useQuery({
    queryKey: ["autocomplete", gnom, query],  // ✅ ADD gnom to queryKey
    queryFn: () => getAutocompleteResults(gnom, query),
    select: ({ data }) => data,
    enabled: Boolean(query) && Boolean(gnom),  // ✅ also guard against empty genome
    staleTime: Infinity,
    retry: false,
  });
};


// Primer Design Download

export const useGetPrimerDesignDownload = (setLoading: any) => {
  const { showNotification } = useNotification();

  return useMutation({
    mutationKey: ["primerDesignDownload"],
    mutationFn: getPrimerDesignDownload,

    onSuccess: ({ data }) => {
      setLoading(false);
      return data;
    },
    onError: (error: any) => {
      setLoading(false);
      showNotification({
        content: error.message || error,
        type: "alert",
      });
    },
  });
};

// const getGenomeValue = (gnome: string) => {
//   if (gnome) {
//     return gnome === "hg38" || gnome === "hg19"
//       ? "hg38"
//       : gnome === "mm39" || gnome === "mm10"
//         ? "mm39"
//         : "";
//   }
// };

const getGenomeValue = (gnome: string) => {
  if (gnome) {
    return gnome === "hg38" || gnome === "hg19"
      ? "hg38"
      : gnome === "mm39" || gnome === "mm10"
        ? "mm39"
        : gnome;  // ✅ return raw value for all other genomes (GRCr8, AGIS1.0, etc.)
  }
};


// In your query file
export const useGetGenomeAssemblies = () => {
  return useQuery({
    queryKey: ["genomeAssemblies"],
    queryFn: async () => {
      const response = await getGenomeAssemblies();
      return response;
    },
    select: (response) => {
      const data = response?.data || response;
      return data;
    },
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 24,
    retry: 2,
  });
};
